import React, { useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

import * as AuthServices from '../services/auth.service';
import { ATLEAST_ONE_CAPITAL_REGEX, ATLEAST_ONE_NUMBER_REGEX, ATLEAST_ONE_SMALL_REGEX, ATLEAST_ONE_SPECIAL_CHARACTER_REGEX, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, ROLE, SWAL_SETTINGS } from "../../../utils/Constants";
import { PHONE_VALIDATION } from "../../../utils/CommonValidatiobn";
import Swal from "sweetalert2";
import { clearUserSession, getUser, handleServerValidations, setLocalKey } from "../../../utils/commonfunction";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addProfileData } from "../../../redux/slices/profileslice";
import { useTranslation } from "react-i18next";

function SignupOtpAdvertiser() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const Dispatch = useDispatch();

  const [submitted, setSubmitted] = useState(false);
  const inputsRef = useRef([]); // store refs to all 6 input boxes
  const phoneInputsRef = useRef([]); // store refs to all 6 input boxes

  // 🔹 Timer
  const [timer, setTimer] = useState(60);

  // Helper to format time as MM:SS
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  // Timer Effect
  React.useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email_otp: "", // single field to hold all 6 digits
      phone_otp: ''
    },
    validationSchema: Yup.object({
      email_otp: Yup.string()
        .length(6, t("vaildation.email_otp_must"))
        .required(t("vaildation.otp_required"))
        .matches(/^[0-9]+$/, t("vaildation.only_number")),
      phone_otp: Yup.string()
        .length(6, t("vaildation.phone_no_must"))
        .required(t("vaildation.otp_required"))
        .matches(/^[0-9]+$/, t("vaildation.only_number")),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      let formData = new FormData();

      formData.append("_id", searchParams.get('user_id'));
      formData.append("emailOtp", values.email_otp);
      formData.append("phoneOtp", values.phone_otp);

      setSubmitted(false);
      AuthServices
        .verifyEmailAndPhoneOTP(formData)
        .then((response) => {
          setSubmitted(true);

          if (response.success) {
            const userDataForUser = getUser(ROLE.USER);
            const isUserFlow = userDataForUser && userDataForUser.token && userDataForUser.role === ROLE.USER;

            if (isUserFlow) {
              const updatedUserData = { ...userDataForUser, ...response.data };
              setLocalKey(ROLE.USER, JSON.stringify(updatedUserData));
              Dispatch(addProfileData(updatedUserData));
            } else {
              clearUserSession();
              setLocalKey(ROLE.ADVERTISER, JSON.stringify(response.data));
              setLocalKey(ROLE.USER, JSON.stringify(response.data));
              Dispatch(addProfileData(response.data));
            }

            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            // navigate('../dashboard');
            // navigate(`../profile-setup?user_id=${searchParams.get('user_id')}`);
            navigate(`../profile-setup`);

            // resetForm({ values: "" });
            // setUpdateData(!updateData);


          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setSubmitted(true);
          console.log("error ====> ", error);
        });
    },
  });

  // handle typing in each box
  const handleEmailOTPChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "").slice(-1);

    const otpArray = formik.values.email_otp.split("").concat(Array(6).fill("")).slice(0, 6);
    otpArray[index] = value;
    formik.setFieldValue("email_otp", otpArray.join(""));

    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  // handle backspace to move to previous input
  const handleEmailOTPKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();

      const otpArray = formik.values.email_otp.split("").concat(Array(6).fill("")).slice(0, 6);
      otpArray[index] = "";
      formik.setFieldValue("email_otp", otpArray.join(""));

      if (index > 0) {
        inputsRef.current[index - 1]?.focus();
      }
    }
  };

  // handle typing in each box
  const handlePhoneOTPChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "").slice(-1);

    const otpArray = formik.values.phone_otp.split("").concat(Array(6).fill("")).slice(0, 6);
    otpArray[index] = value;
    formik.setFieldValue("phone_otp", otpArray.join(""));

    if (value && index < 5) {
      phoneInputsRef.current[index + 1]?.focus();
    }
  };

  // handle backspace to move to previous input
  const handlePhoneOTPKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();

      const otpArray = formik.values.phone_otp.split("").concat(Array(6).fill("")).slice(0, 6);
      otpArray[index] = "";
      formik.setFieldValue("phone_otp", otpArray.join(""));

      if (index > 0) {
        phoneInputsRef.current[index - 1]?.focus();
      }
    }
  };

  // helper: get character at given position
  const getEmailChar = (index) => formik.values.email_otp[index] || "";

  const getPhoneChar = (index) => formik.values.phone_otp[index] || "";

  const resendOTP = () => {
    if (timer > 0) return;

    let formData = new FormData();
    formData.append("_id", searchParams.get("user_id"));

    AuthServices.resendEmailAndPhoneOtp(formData)
      .then((response) => {
        if (response.success) {
          Swal.fire({
            icon: "success",
            text: response.message,
            ...SWAL_SETTINGS,
          });
          setTimer(60);
        } else {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
        }
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
  };

  return (
    <section className="py-8 md:py-12 lg:py-16 form-bg">
      <div className="container">
        <div className="mb-8">
          <h1 className="headings-h1 text-center text-zinc-950 mb-2">
            {t("advertiser.otp_verification.heading")}
          </h1>
        </div>
        <div className="bg-white p-[15px] md:p-[50px] rounded-[10px] max-w-[475px] shadow-[0px_2px_24px_rgba(0,0,0,0.05)] w-full mx-auto border border-zinc-100 w-full">
          <form onSubmit={formik.handleSubmit}>
            {/* <div className="otp-box flex items-center gap-[10px]">
              <input
                type="text"
                className="form-control-custom text-center"
                placeholder="0"
              />
              <input
                type="text"
                className="form-control-custom text-center"
                placeholder="0"
              />
              <input
                type="text"
                className="form-control-custom text-center"
                placeholder="0"
              />
              <input
                type="text"
                className="form-control-custom text-center"
                placeholder="0"
              />
              <input
                type="text"
                className="form-control-custom text-center"
                placeholder="0"
              />
              <input
                type="text"
                className="form-control-custom text-center"
                placeholder="0"
              />
            </div> */}
            <p className="text-center text-zinc-500 body-lg mb-3">
              {t("advertiser.otp_verification.email_title")}
            </p>
            <div className="otp-box flex items-center gap-[10px] justify-center">
              {[...Array(6)].map((_, index) => (
                <input
                  key={index}
                  type="text"
                  onFocus={(e) => e.target.select()}
                  ref={(el) => (inputsRef.current[index] = el)}
                  value={getEmailChar(index)}
                  onChange={(e) => handleEmailOTPChange(e, index)}
                  onKeyDown={(e) => handleEmailOTPKeyDown(e, index)}
                  className="form-control-custom text-center w-10 h-10 border border-gray-300 rounded focus:border-blue-500 focus:outline-none"
                />
              ))}
              <span className="text-danger text-left d-blockerr-spn">
                {formik.errors.email_otp && formik.touched.email_otp && formik.errors.email_otp}
              </span>
            </div>

            <p className="text-center text-zinc-500 body-lg mt-4 pt-2 mb-3">
              {t("advertiser.otp_verification.mobile_title")}
            </p>
            <div className="otp-box flex items-center gap-[10px] justify-center">
              {[...Array(6)].map((_, index) => (
                <input
                  key={index}
                  type="text"
                  onFocus={(e) => e.target.select()}
                  ref={(el) => (phoneInputsRef.current[index] = el)}
                  value={getPhoneChar(index)}
                  onChange={(e) => handlePhoneOTPChange(e, index)}
                  onKeyDown={(e) => handlePhoneOTPKeyDown(e, index)}
                  className="form-control-custom text-center w-10 h-10 border border-gray-300 rounded focus:border-blue-500 focus:outline-none"
                />
              ))}
              <span className="text-danger text-left d-blockerr-spn">
                {formik.errors.phone_otp && formik.touched.phone_otp && formik.errors.phone_otp}
              </span>
            </div>

            <button type="submit" className="btn btn-pri w-full mt-4">
              {t("btn_verify")}
            </button>
          </form>
        </div>
        <div className="mt-8 text-center body-md text-zinc-700">
          {timer > 0 ? (
            <p className="text-gray-500">
              {t("code_not_receive")}
              <span className="font-bold text-blue-600 ml-2">{formatTime(timer)}</span>
            </p>
          ) : (
            <div>
              {t("code_not_receive")}
              <button
                type="button"
                className="headings-h6 bold text-[var(--secondary-400)] ml-2 hover:underline"
                onClick={resendOTP}
              >
                {t("btn_resend")}
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default SignupOtpAdvertiser;
